import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit", "value"]

  connect() {
    this.#syncDigitsFromValue()
  }

  input(event) {
    const digits = event.target.value.replace(/\D/g, "")
    if (digits.length > 1) {
      this.#fill(digits)
      return
    }

    event.target.value = digits
    this.#writeValue()
    if (digits) this.#focusOffset(event.target, 1)
  }

  keydown(event) {
    const input = event.target

    if (/^\d$/.test(event.key)) {
      event.preventDefault()
      input.value = event.key
      this.#writeValue()
      this.#focusOffset(input, 1)
      return
    }

    if (event.key === "Backspace") {
      event.preventDefault()
      if (input.value) {
        input.value = ""
        this.#writeValue()
        return
      }
      const previous = this.#focusOffset(input, -1)
      if (previous) {
        previous.value = ""
        this.#writeValue()
      }
      return
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault()
      this.#focusOffset(input, -1)
      return
    }

    if (event.key === "ArrowRight") {
      event.preventDefault()
      this.#focusOffset(input, 1)
      return
    }

    if (event.key === "Delete") {
      event.preventDefault()
      input.value = ""
      this.#writeValue()
    }
  }

  paste(event) {
    event.preventDefault()
    const text = (event.clipboardData || window.clipboardData).getData("text")
    this.#fill(text.replace(/\D/g, ""))
  }

  #fill(digits) {
    const chars = digits.slice(0, this.digitTargets.length).split("")
    this.digitTargets.forEach((input, index) => {
      input.value = chars[index] || ""
    })
    this.#writeValue()
    const next = this.digitTargets[Math.min(chars.length, this.digitTargets.length - 1)]
    this.#focus(next)
  }

  #writeValue() {
    if (!this.hasValueTarget) return
    this.valueTarget.value = this.digitTargets.map((input) => input.value).join("")
  }

  #syncDigitsFromValue() {
    if (!this.hasValueTarget) return
    const chars = this.valueTarget.value.replace(/\D/g, "").split("")
    if (!chars.length) return

    this.digitTargets.forEach((input, index) => {
      if (!input.value) input.value = chars[index] || ""
    })
  }

  #focusOffset(input, offset) {
    const next = this.digitTargets[this.digitTargets.indexOf(input) + offset]
    this.#focus(next)
    return next
  }

  #focus(input) {
    if (!input) return
    input.focus()
    input.select()
  }
}
